// src/components/BackButton.js
// -----------------------------------------------------------------------------
// The one back control, for every app surface.
//
// It was five different buttons across SmartData, SmartFinance, SmartShop Home,
// Products and Assets - different sizes, colours and labels, and small enough to hunt
// for. Navigation furniture should be identical everywhere: a person moving between
// apps should never have to re-learn where "back" is.
//
// Brand-coloured via --ss-accent, so it carries the tenant's colour wherever that is
// set and falls back to the house red where it is not.
//
// House rule: short hyphen "-" only.
// -----------------------------------------------------------------------------
import React from 'react';

export default function BackButton({ onClick, label, title }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title || 'Back'}
      aria-label={title || 'Back'}
      style={{
        background: 'rgba(255,255,255,0.05)',
        color: 'var(--ss-accent, #8B1A1A)',
        border: '1px solid var(--ss-accent, #8B1A1A)',
        padding: label ? '7px 16px' : '6px 16px',
        fontWeight: 900,
        fontSize: label ? 12 : 20,
        lineHeight: 1.1,
        letterSpacing: label ? '0.1em' : 0,
        textTransform: label ? 'uppercase' : 'none',
        fontFamily: 'inherit',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: 20, lineHeight: 1 }}>&larr;</span>
      {label && <span>{label}</span>}
    </button>
  );
}